import React, { FC, ReactNode } from 'react';
import { styled } from '@mui/material/styles';
import { ConstantsCodeType } from 'src/types/constantsCodes';
import getStatusColor from 'src/utils/getStatusColor';

export const StatusIcon = styled('div')({
    paddingLeft: '11px',
    paddingRight: '11px',
    display: 'flex',
    alignItems: 'center',

    '& > svg': {
        width: '36px',
        height: '36px',
        marginRight: '10px',
    },
});

export interface StatusLabelPropsType {
    option?: ConstantsCodeType;
    icon?: ReactNode;
    label?: string;
    color?: string;
}

const StatusLabel: FC<StatusLabelPropsType> = ({ option, icon, label, color }) => {
    const text = label ?? option?.label ?? '';
    const statusColor = getStatusColor(color ?? option?.color);
    const content = <span style={{ color: statusColor }}>{text}</span>;

    if (icon) {
        return (
            <StatusIcon>
                {icon}
                {content}
            </StatusIcon>
        );
    }

    return content;
};

export default StatusLabel;
